export default __webpack_public_path__ + "8b36f68aded8353351a24b34c9cf345a.svg";